import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'sanitize.css/sanitize.css';
import './index.css';
import './locales/i18n';

import useFeatureFlags from '@hooks/useFeatureFlags';
import { ensureRemoteConfigReady } from '@service/firebase';
import UserManagerClient from '@service/UserManagerClient';
import App from 'app';
import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';

import AutoLoginGuard from './auth/AutoLoginGuard';
import TokenStorageBridge from './auth/TokenStorageBridge';
import log from './datadog';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

const AppWrapper = () => {
  const { features } = useFeatureFlags();

  const oidcConfig = {
    userManager: UserManagerClient,
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  return (
    <HelmetProvider>
      <AuthProvider {...oidcConfig}>
        <BrowserRouter>
          <React.StrictMode>
            {features.isKeycloakLoginWithSso() ? (
              <AutoLoginGuard>
                <TokenStorageBridge />
                <App />
              </AutoLoginGuard>
            ) : (
              <App />
            )}
          </React.StrictMode>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
};

const renderApp = async () => {
  log.initialize();

  await ensureRemoteConfigReady();

  ReactDOMClient.createRoot(MOUNT_NODE).render(<AppWrapper />);
};

renderApp();
